import {connect} from 'external/react'
import {size, toArray} from 'external/lodash'
import {clsx, makeStyles, AttachFileIcon} from 'external/material'
import {viewerGuard} from 'utils/url'

const useStyles = makeStyles(createStyles)

const UploadedFiles = props => {
  const {fileProgress, downloadServer} = props
  const uploadedFileAmount = size(fileProgress)
  const classes = useStyles() 
  const contentLink = file => {
    return `${downloadServer}${file.folder}/${file.file.name}`
  }

  return uploadedFileAmount > 0 ? (
    <div className={clsx(classes.wrapper)}>      
      {size(fileProgress)
        ? toArray(fileProgress).filter(f => !f.deleted)
          .map(file => { return (   
            <div key={file.id}>
              <AttachFileIcon />
              <a {...viewerGuard({href: contentLink(file), target: "_blank"})}>{file.file.name}</a>
            </div> 
          )})
        : null}
    </div>
  ) : null
}

const mapStateToProps = state => ({
  fileProgress: state.UploadFile.fileProgress,
})


export default connect(mapStateToProps)(UploadedFiles)


function createStyles(theme) {  
  return {
    root: {      
    },
    wrapper: {
      
    }
  }
}
